<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="应用分类" prop="CategoryID">
                <el-select v-model="model.CategoryID" placeholder="请选择应用分类">
                    <el-option :label="item.Name" :value="item.OID" v-for="(item,index) in appTypeList" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="应用名称" prop="Name">
                <el-input size="small" v-model="model.Name" auto-complete="off" placeholder="请输入应用名称" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用类型" prop="AppType">
                <el-radio-group v-model="model.AppType">
                    <el-radio label="web"></el-radio>
                    <el-radio label="android"></el-radio>
                    <el-radio label="windows"></el-radio>
                    <el-radio label="ios"></el-radio>
                    <el-radio label="dingding"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="应用图标" prop="Icon" style="text-align: left">
                <el-upload class="upload-demo" action="" :on-change="handleLogoChange" :http-request="handleHttpRequestLogo" :on-exceed="handleLogoOver" :before-upload="beforeAvatarLogo" :limit="limitLogo" accept="image/*" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">图片大小不超过 300k</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="应用图标插画" prop="Icon1" style="text-align: left" v-if="model.AppType =='android'">
                <el-upload class="upload-demo" action="" :on-change="handleIcon1Change" :http-request="handleHttpRequestIcon1" :on-exceed="handleLogoOver" :before-upload="beforeAvatarLogo" :limit="limitLogo" accept="image/*" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <!-- <span>安卓新版本插画</span> -->
                    <div slot="tip" class="el-upload__tip">图片大小不超过 300k</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="图标颜色" prop="IconColor" v-if="model.AppType =='android'">
                <el-color-picker v-model="model.IconColor"></el-color-picker>
            </el-form-item>
            <el-form-item label="图标阴影颜色" prop="IconShadow" v-if="model.AppType =='android'">
                <el-color-picker v-model="model.IconShadow"></el-color-picker>
            </el-form-item>
            <el-form-item label="应用跳转路径" prop="Url">
                <el-input size="small" v-model="model.Url" auto-complete="off" placeholder="请输入跳转路径" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用安装包" prop="DownloadUrl" v-if="model.AppType =='android'">
                <el-upload class="upload-demo" action="" :on-change="handleDownloadUrlChange" :http-request="handleHttpRequestDownload" :on-exceed="handleDownloadOver" :limit="limitDownload" :file-list="fileDownloadUrlList" accept=".apk,.exe" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">文件类型只能是.apk或者.exe类型的</div>
                </el-upload>
                <p v-if="this.model.DownloadUrl">应用安装包路径：{{this.model.DownloadUrl}}</p>
            </el-form-item>
            <el-form-item label="应用发布者" prop="Developer">
                <el-input size="small" v-model="model.Developer" auto-complete="off" placeholder="请输入应用发布者" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="是否有管理后台" prop="IsBackStage">
                <el-switch v-model="model.IsBackStage"></el-switch>
            </el-form-item>
            <el-form-item label="应用描述" prop="Descript">
                <el-input type="textarea" v-model="model.Descript" placeholder="请输入应用描述" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="应用图片" prop="Images">
                <el-upload class="upload-demo" action="" :on-change="handleBannerChange" :http-request="handleHttpRequestBanner" :before-remove="handleBannerRemove" :before-upload="beforeAvatarBanner" accept="image/*" list-type="picture">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">图片单张大小不超过 1M</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="是否显示" prop="IsShow">
                <el-switch v-model="model.IsShow"></el-switch>
            </el-form-item>
            <el-form-item label="初始化数据库表Key" prop="InitDataKey">
                <el-input v-model="model.InitDataKey" placeholder="请输入数据库表Key" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import { AddApp } from '../../api/app'
    import { GetAppCategoryList } from '../../api/appType'
    import { Upload } from '../../api/common'
    export default {
        data() {
            return {
                title: '添加应用',
                name: 'add',
                labelwidth: '160px',
                labelPosition: 'right',
                imagesList: [],
                appTypeList: [],

                limitLogo: 1,
                limitDownload: 1,
                baseURL: window.Global.baseURL,
                languageOptions: ['cn', 'en'],
                model: {
                    CategoryID: '',
                    Name: '',
                    AppType: '',
                    Icon: '',
                    IconColor: '',
                    IconShadow: '',
                    Url: '',
                    Developer: '',
                    Descript: '',
                    Images: '',
                    IsShow: true,
                    IsBackStage: false,
                    DownloadUrl: '',
                    InitDataKey: ''
                },
                rules: {
                    CategoryID: [{ required: true, message: '请输入应用分类', trigger: 'change' }],
                    Name: [{ required: true, message: '请输入应用名称', trigger: 'blur' }],
                    AppType: [{ required: true, message: '请输入应用类型', trigger: 'change' }],
                    Icon: [{ required: true, message: '请输入应用图标', trigger: 'blur' }],
                    // Icon1: [{ required: true, message: '请输入应用图标插画', trigger: 'blur' }],
                    Url: [{ required: true, message: '请输入应用跳转路径', trigger: 'blur' }],
                    Developer: [{ required: true, message: '请输入应用开发者', trigger: 'blur' }],
                    IsShow: [{ required: true, message: '请选择应用是否显示', trigger: 'change' }],
                    IsBackStage: [{ required: true, message: '请选择是否有应该管理后台', trigger: 'change' }],
                },
                fileLogoList: [],
                fileIcon1List: [],
                fileBannerList: [],
                fileDownloadUrlList: [],

            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.GetAppCategoryList();
            },
            GetAppCategoryList() {
                GetAppCategoryList().then(data => {
                    if (!data.iserror) {
                        this.appTypeList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleSave() {
                if (this.imagesList.length > 0) {
                    this.model.Images = this.imagesList.join('|');
                }
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.AddApp()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeAddDialog')
            },
            AddApp() {
                AddApp(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            handleLogoChange(file, fileList) {
                this.fileLogoList = fileList.slice(-1);
            },
            handleIcon1Change(file, fileList) {
                this.fileIcon1List = fileList.slice(-1);
            },
            handleLogoOver() {
                this.$message({
                    message: '只能上传一张应用图标',
                    type: 'error'
                });
            },
            beforeAvatarLogo(file) {
                let isLimit100 = file.size / 1024 < 300;
                let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
                if (!isLimit100) {
                    this.$message({
                        message: '图标大小不能超过300k',
                        type: 'error'
                    });
                    return false;
                }
                // if(reg.test(file.name)){
                //     this.$message({
                //         message: '图片名称不能包含中文字符',
                //         type: 'error'
                //     });
                //     return false;
                // }
                // const isSize = new Promise((resolve, reject) => {
                //     const _URL = window.URL || window.webkitURL;
                //     const img = new Image();
                //     img.onload = () => {
                //         const valid = img.width === img.height;
                //         valid ? resolve() : reject();
                //     };
                //     img.src = _URL.createObjectURL(file);
                // }).then(
                //     () => {
                //         return file;
                //     },
                //     () => {
                //         this.$message.error('图标宽高比例应为1:1');
                //         return Promise.reject();
                //     },
                // );
                // return isSize;
            },
            handleHttpRequestLogo(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.model.Icon = this.baseURL + data.data.filePath;
                    }
                })
            },
            handleHttpRequestIcon1(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.model.Icon1 = this.baseURL + data.data.filePath;
                    }
                })
            },
            handleBannerChange(file, fileList) {
                this.fileBannerList = fileList.slice(-1);
            },
            handleBannerRemove(file, fileList) {
                fileList.forEach((element, index) => {
                    if (file === element) {
                        this.imagesList.splice(index, 1);
                    }
                });
            },
            beforeAvatarBanner(file) {
                let isLimit100 = file.size / 1024 < 1024;
                if (!isLimit100) {
                    this.$message({
                        message: '图片大小不能超过1M',
                        type: 'error'
                    });
                    return false;
                }
            },
            handleHttpRequestBanner(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.imagesList.push(this.baseURL + data.data.filePath)
                    }
                })
            },
            handleDownloadUrlChange(file, fileList) {
                this.fileDownloadUrlList = fileList.slice(-1);
            },
            handleDownloadOver() {
                this.$message({
                    message: '只能上传一个文件',
                    type: 'error'
                });
            },
            handleHttpRequestDownload(a) {
                var formdata = new FormData();
                formdata.append('file', a.file)
                console.log(formdata)
                Upload(formdata).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '文件上传成功',
                            type: 'success'
                        });
                        this.model.DownloadUrl = this.baseURL + data.data.filePath;
                    }
                })
            },
        }
    }
</script>

<style>

</style>